import i18n from "i18n";
import { createColumns } from "common/helpers/createColumn";

export const columns = createColumns(
  {
    dataField: "reportID",
    text: i18n.t("labelReportNumber"),
  },
  {
    dataField: "reportCreationTime",
    text: i18n.t("reportDate"),
  },
  {
    dataField: "firstDecision",
    text: i18n.t("initialDescision"),
  },
  {
    dataField: "lastDecision",
    text: i18n.t("finalDescision"),
  }
);
